import React from 'react';
import { FlowNodeTypeEnum, FlowPartType } from '$/domains/node/type';

export type NodeOptionIntroType = {
  functionTitle: string;
  functionText: string;
  supportTitle: string;
  supportActions: Array<{
    type: 'icon' | 'text';
    label?: string;
    icon?: {
      name: string;
      fontSize: number;
      color: string;
      style?: React.CSSProperties;
    };
  }>;
};

export type NodeOption = {
  nodeType: FlowNodeTypeEnum;
  icon: {
    name: string;
    fontSize: number;
    color?: string;
    style?: React.CSSProperties;
  };
  label: string;
  extra?: React.ReactNode;
  intro?: NodeOptionIntroType;
};

export type NodeType = {
  icon: {
    name: string;
    fontSize: number;
  };
  label: string;
  options: Array<NodeOption>;

};

export const inputNodeFlowType = [FlowNodeTypeEnum.TEXT_NODE, FlowNodeTypeEnum.IMAGE_NODE, FlowNodeTypeEnum.VIDEO_NODE, FlowNodeTypeEnum.AUDIO_NODE];
export const editNodeFlowType = [FlowNodeTypeEnum.TEXT_EDIT_NODE, FlowNodeTypeEnum.IMAGE_EDIT_NODE, FlowNodeTypeEnum.VIDEO_EDIT_NODE, FlowNodeTypeEnum.GIF_EDIT_NODE, FlowNodeTypeEnum.AUDIO_EDIT_NODE];

export const inputPortType = [FlowPartType.TEXT, FlowPartType.IMAGE, FlowPartType.VIDEO, FlowPartType.AUDIO];

export const inputNode: NodeType = {
  icon: {
    name: 'squarePlusBold',
    fontSize: 18,
  },
  label: 'roboneo_web_input_node',
  options: [
    {
      nodeType: FlowNodeTypeEnum.TEXT_NODE,
      icon: {
        name: 'typefaceBold',
        fontSize: 18,
      },
      label: 'roboneo_web_text',
      extra: 'T',
    },
    {
      nodeType: FlowNodeTypeEnum.IMAGE_NODE,
      icon: {
        name: 'pictureBold',
        fontSize: 18,
      },
      label: 'roboneo_web_image',
      extra: 'I',
    },
    {
      nodeType: FlowNodeTypeEnum.VIDEO_NODE,
      icon: {
        name: 'videoV4Bold',
        fontSize: 18,
      },
      label: 'roboneo_web_video',
      extra: 'V',
    },
    {
      nodeType: FlowNodeTypeEnum.AUDIO_NODE,
      icon: {
        name: 'musicV2Bold',
        fontSize: 18,
      },
      label: 'roboneo_web_audio',
      extra: 'A',
    },
  ],
};
